var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 6.89298C14.8571 4.78369 14.0537 2.76079 12.6234 1.2693C12.2791 0.910235 11.7209 0.910235 11.3766 1.26929C9.94635 2.76079 9.14286 4.78369 9.14286 6.89298V11.4201L7.78958 12.1259C7.30567 12.3783 7 12.8941 7 13.4583V15.1447C7 15.3504 7.15992 15.5172 7.35719 15.5172H16.6428C16.8401 15.5172 17 15.3504 17 15.1447V13.4583C17 12.8941 16.6943 12.3783 16.2104 12.1259L14.8571 11.4201V6.89298Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62424 17.7403C9.62424 17.3271 9.29467 16.9922 8.88813 16.9922C8.48158 16.9922 8.15201 17.3271 8.15201 17.7403V21.2311C8.15201 21.6442 8.48158 21.9791 8.88813 21.9791C9.29467 21.9791 9.62424 21.6442 9.62424 21.2311V17.7403Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2928 16.9922C15.6993 16.9922 16.0289 17.3271 16.0289 17.7403V21.2311C16.0289 21.6442 15.6993 21.9791 15.2928 21.9791C14.8862 21.9791 14.5566 21.6442 14.5566 21.2311V17.7403C14.5566 17.3271 14.8862 16.9922 15.2928 16.9922Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8488 18.9979C12.8488 18.5847 12.5192 18.2498 12.1127 18.2498C11.7061 18.2498 11.3766 18.5847 11.3766 18.9979V22.2521C11.3766 22.6652 11.7061 23.0001 12.1127 23.0001C12.5192 23.0001 12.8488 22.6652 12.8488 22.2521V18.9979Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketStart);
export default __webpack_public_path__ + "static/media/rocket-start.ff6e0c6945bf7d7cd5e48b333638a655.svg";
export { ForwardRef as ReactComponent };